import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPilone"><Path d="M7.48828 8L9.25299 2H14.7495L16.5142 8H7.48828Z" fill="currentColor"/><Path d="M6.89798 10L6.01562 13H17.9827L17.1003 10H6.89798Z" fill="currentColor"/><Path d="M18.5718 15H5.42823L4.25176 19H2V21H22V19H19.7482L18.5718 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPilone;
